<div class="container-fluid vh-100 d-flex align-items-center justify-content-center">
  <div class="row w-100 overflow-hidden">
    <!-- Left Side: Sign In Form -->
    <div class="col-12 col-md-6 bg-white left-side">
      <div class="mb-4">
        <img src="assets/icons/icon.svg" alt="logo" class="mb-5 img-icon" />
        <h1>{{ 'SIGN_IN.SIGN_IN_HEADING' | translate }}</h1>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label
            for="email"
            [ngClass]="{
            'input-valid': loginForm.controls['email'].valid && loginForm.controls['email'].touched,
            'input-invalid': !loginForm.controls['email'].valid
            }"
          >
            {{ 'SIGN_IN.EMAIL_ADDRESS' | translate }}
          </label>
          <input
            type="email"
            id="email"
            class="form-control p-3"
            formControlName="email"
            placeholder="{{ 'SIGN_IN.EMAIL_ADDRESS' | translate }}"
          />
          <div
            *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched"
            class="validation-error"
          >
            {{ 'SIGN_IN.ERROR_MESSAGE.EMAIL_ERROR' | translate }}
          </div>
        </div>
        <div class="form-group mb-4">
          <label
            for="password"
            [ngClass]="{
              'input-valid': loginForm.controls['password'].valid && loginForm.controls['password'].touched,
              'input-invalid': !loginForm.controls['password'].valid
              }"
          >
            {{ 'SIGN_IN.YOUR_PASSWORD' | translate }}
          </label>
          <p-password
            [toggleMask]="true"
            inputId="password"
            formControlName="password"
            [feedback]="false"
            placeholder="{{ 'SIGN_IN.YOUR_PASSWORD' | translate }}"
            pattern="^.*[a-zA-Z0-9].{3,}"
            required
          ></p-password>
        </div>
        <button
          pButton
          title="signIn button"
          type="submit"
          label="{{ 'SIGN_IN.SIGN_IN_BTN' | translate }}"
          [rounded]="true"
          class="btn-submit p-button-raised p-button-primary p-2 w-100"
          [disabled]="loginForm.invalid || isLoading"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
        </button>
        <div *ngIf="authError" class="mt-3 alert alert-danger">{{ authError }}</div>
      </form>
    </div>

    <!-- Right Side: Welcome Section -->
    <div class="col-12 col-md-6 d-none d-md-flex align-items-center justify-content-center p-0">
      <img src="assets/images/login-backgroud.svg" alt="background image" class="img-bg" />
    </div>
  </div>
</div>
